import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import "antd/dist/reset.css";
import { UsernameProvider } from "./UsernameContext";
import Router from "./router";
import i18n from "./translation";
import { AuthProvider } from "./AuthProvider";
import { ThemeProvider } from "./styles/theme/ThemeProvider";
import "./styles/index.css";

import { initGA } from "./analytics";
import GAListener from "./GAlistener";
import RootApp from "./RootApp";
import ErrorBoundary from "./common/ErrorBoundary";

initGA();

const App = () => (
  <ErrorBoundary>
    <BrowserRouter>
      <GAListener />
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <ThemeProvider>
            <UsernameProvider>
              <RootApp />
            </UsernameProvider>
          </ThemeProvider>
        </AuthProvider>
      </I18nextProvider>
    </BrowserRouter>
  </ErrorBoundary>
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
